import { Routes, Route, Navigate, BrowserRouter as Router } from "react-router-dom";
import LoginPage from "./components/pages/Login";
import Dashboard from "./components/pages/Dashboard";
import RequireAuth from "./components/common/RequireAuth";
import Layout from "./components/common/Layout";
import RulePage from "./components/pages/RulesPage";
import Rulebook from "./components/pages/Rulebook";
import { NotificationProvider } from "./components/common/NotificationContext";
import { SettingsProvider } from "./components/context/SettingsContext";
import { PermissionsProvider } from "./components/context/PermissionsContext";
import ViewValidationResult from "./components/pages/ViewValidationResult";
import { ROLES } from "./config/permissions";

const AppRoutes = () => (
  <Router>
    <PermissionsProvider>
      <NotificationProvider>
        <SettingsProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            <Route
              path="/"
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route
                path="dashboard"
                element={
                  <RequireAuth role={ROLES.USER}>
                    <Dashboard />
                  </RequireAuth>
                }
              />
              <Route
                path="rule"
                element={
                  <RequireAuth role={ROLES.PAYROLL_ANALYST}>
                    <RulePage />
                  </RequireAuth>
                }
              />
              <Route
                path="rulebook"
                element={
                  <RequireAuth role={ROLES.PAYROLL_MANAGER}>
                    <Rulebook />
                  </RequireAuth>
                }
              />
              <Route
                path="insights"
                element={
                  <RequireAuth role={ROLES.USER}>
                    <ViewValidationResult />
                  </RequireAuth>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </SettingsProvider>
      </NotificationProvider>
    </PermissionsProvider>
  </Router>
);

export default AppRoutes;
